export default __webpack_public_path__ + "static/media/me_head.7eaee300.png";